export default {
  pages: require("./pages").default,
  products: require("./products").default,
  classification: require("./classification").default,
  brands: require("./brands").default,
  users: require("./users").default,
  // pages: [
  //   { home: require('./pages/home').default },
  //   { about: require('./pages/about-us').default },
  //   { terms: require('./pages/terms-and-conditions').default },
  //   { contact: require('./pages/contact-us').default }
  // ]
};
